import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import type { BotSummary } from "@/types/bot";
import { getBotAvatarSrc } from "./getBotAvatarSrc";

interface BotCardProps {
  bot: BotSummary;
  onClick: (botId: string) => void;
}

export function BotCard({ bot, onClick }: BotCardProps) {
  const avatarSrc = getBotAvatarSrc(bot);
  return (
    <Card
      data-testid={`bot-card-${bot.id}`}
      className="jr-card cursor-pointer gap-0 border-[color:var(--jr-border)] py-0 transition-all hover:-translate-y-1 hover:border-[color:var(--jr-border-strong)]"
      onClick={() => onClick(bot.id)}
    >
      <CardContent className="flex min-h-[180px] flex-col items-center gap-3 p-5 text-center md:min-h-[240px] md:p-6">
        <div className="relative">
          <Avatar className="jr-avatar-ring h-20 w-20 md:h-28 md:w-28">
            <AvatarImage src={avatarSrc} alt={bot.name} />
            <AvatarFallback className="bg-[color:var(--jr-surface-muted)] text-2xl font-semibold text-[color:var(--jr-accent)] md:text-3xl">
              {bot.name.charAt(0)}
            </AvatarFallback>
          </Avatar>
        </div>

        <div className="min-w-0">
          <h3 className="jr-display text-lg font-semibold leading-tight text-[var(--jr-text)] md:text-xl">
            {bot.name}
          </h3>
          <p className="mt-1 line-clamp-2 text-sm text-[var(--jr-text-muted)]">
            {bot.description}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
